function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3994 3.69993H5.65439L6.12439 3.22993C6.74439 2.60493 6.74439 1.58493 6.12439 0.964929C5.60118 0.445909 4.80131 0.361679 4.19087 0.711624C4.0721 0.779714 3.96037 0.863944 3.85939 0.964924L0.46439 4.35992C-0.15561 4.98492 -0.15561 6.00492 0.46439 6.62492L3.85939 10.0199C3.96118 10.1209 4.07359 10.2051 4.19291 10.2732C4.80617 10.6232 5.60537 10.5389 6.12439 10.0199C6.74439 9.39492 6.74439 8.37492 6.12439 7.75492L5.26939 6.89992H12.7994V11.6999C12.7994 12.5799 13.5194 13.2999 14.3994 13.2999C15.2794 13.2999 15.9994 12.5799 15.9994 11.6999V5.29992C15.9994 4.41993 15.2794 3.69993 14.3994 3.69993Z"
});

var SvgReply = function SvgReply(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "#6B6C7E",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReply, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reply.089afac1.svg";
export { ForwardRef as ReactComponent };